import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import routes from '../../../../routes';
import { appMetaSelectors } from '../../../../store/modules/appMeta';

import { useFetchFolderAction } from './useFetchFolder';

const { Router } = routes;

const useReFreshOnWorkspaceChanged = () => {
  const workspace = useSelector(appMetaSelectors.selectWorkspace);
  const isFirstRenderRef = useRef(true);
  const [_, { fetchFolders }] = useFetchFolderAction();

  useEffect(() => {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      return;
    }

    Router.router?.asPath === '/videos' ? fetchFolders() : Router.pushRoute('my-projects');
  }, [workspace]);
};

export default useReFreshOnWorkspaceChanged;
